module.exports = __webpack_public_path__ + "img/utpl.abd0d663.png";